module.exports = "./img/80efcfbc651d98e98f228b910d57040c.jpg";